import React from 'react';
import { Star, Quote } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { reviews } from '../mock/mock';

const Testimonials = () => {
  const { t } = useApp();
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-3xl mb-12">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-[color:var(--brand-dark)]">{t('reviews.title')}</h2>
          <p className="mt-4 text-gray-500 leading-relaxed">{t('reviews.subtitle')}</p>
          <div className="mt-6 flex flex-wrap gap-6">
            {[['Trustpilot','4.7'],['Google','4.4'],['TripAdvisor','4.5']].map(([n,s]) => (
              <div key={n} className="flex items-center gap-2">
                <div className="flex">{[...Array(5)].map((_,i)=>(<Star key={i} className="w-4 h-4 fill-current" style={{color:'#f5b301'}} />))}</div>
                <span className="text-sm font-bold text-[color:var(--brand-dark)]">{s}</span>
                <span className="text-xs text-gray-400">{n}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <div key={i} className="card-hover bg-[color:var(--brand-muted)] rounded-2xl p-6 flex flex-col">
              <Quote className="w-8 h-8 mb-3" style={{ color: 'var(--brand-accent-hover)' }} />
              <div className="flex mb-3">{[...Array(r.rating)].map((_,j)=>(<Star key={j} className="w-4 h-4 fill-current" style={{color:'#f5b301'}} />))}</div>
              <p className="text-sm text-gray-600 leading-relaxed flex-1">{r.text}</p>
              <div className="mt-5 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm" style={{ backgroundColor: 'var(--brand-dark)', color: 'var(--brand-accent)' }}>{r.name.charAt(0)}</div>
                <div>
                  <div className="font-bold text-sm text-[color:var(--brand-dark)]">{r.name}</div>
                  <div className="text-xs text-gray-400">{r.date}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
